import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Serene%20minimalist%20bedroom%20at%20night%20with%20soft%20warm%20amber%20lighting%2C%20gentle%20moonlight%20streaming%20through%20sheer%20curtains%2C%20cozy%20atmosphere%20with%20plush%20bedding%2C%20diffused%20candlelight%20glow%2C%20peaceful%20and%20calming%20aesthetic%2C%20editorial%20photography%20with%20dreamy%20soft%20focus%2C%20warm%20earth%20tones%20and%20cream%20textures%2C%20minimalist%20interior%20design&width=1920&height=1080&seq=hero-asmr-01&orientation=landscape"
        alt="ASMR免费网页 - 在线免费收听ASMR助眠白噪音"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <p className="text-background-50/80 text-sm md:text-base tracking-widest mb-4 font-label animate-fadeIn">
          在线免费收听 · 无需下载 · 无需注册
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight max-w-4xl mx-auto animate-fadeInUp">
          用声音抚慰心灵
          <br />
          <span className="text-primary-300">享受极致的放松体验</span>
        </h1>
        <p className="text-background-50/70 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed animate-fadeInUp delay-200">
          ASMR免费网页为您提供海量ASMR音频在线免费收听，涵盖助眠、解压、专注等多种场景。
          随时随地舒缓压力、改善睡眠质量，开启您的听觉疗愈之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fadeInUp delay-300">
          <Link
            to="/category/zhumian"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-moon-line mr-2"></i>
            开始放松之旅
          </Link>
          <Link
            to="/category/ziranyin"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full text-base border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-leaf-line mr-2"></i>
            聆听自然声音
          </Link>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 md:gap-12 animate-fadeInUp delay-500">
          {[
            { value: '10万+', label: '日活跃用户' },
            { value: '500+', label: '精选音频' },
            { value: '6', label: '场景分类' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}